import React from 'react'
import classNames from 'classnames'
import './style.scss'

const RawHTML = ({ content, className = '', nl2br }) => {
  const text = nl2br ? content.replace(/\n/g, '<br />') : content
  return (<div className={classNames('htmlContainer', className)} dangerouslySetInnerHTML={{ __html: text }} />)
}

export default RawHTML